/* eslint import/prefer-default-export: off */

enum codes {
  DA_DEGREE = 'HS-DA',
  DA_DIPLOMA = 'DA',
  HCA_DEGREE = 'HCA',
  HCM_DEGREE = 'HCM',
  HHS_DEGREE = 'HHS',
  HIM_DEGREE = 'HIM',
  HIT_DEGREE = 'UNSPEC',
  MA_DEGREE = 'HS-MA',
  MA_DIPLOMA = 'MA',
  MAA_DEGREE = 'HS-MAA',
  MAA_DIPLOMA = 'MAA',
  MBC_DEGREE = 'MBCOA',
  MBC_DIPLOMA = 'MBC',
  MOBS_DEGREE = 'HS-MOBS',
  MOBS_DIPLOMA = 'MOBS',
  PHT_DEGREE = 'HS-PHT',
  NA_DIPLOMA = 'NA',
  PCT_DIPLOMA = 'PCT',
  PH_DIPLOMA = 'PH',
  UNKNOWN = 'UNSPEC',
}

export { codes }
